import React from "react";
import { Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import { PAGE_NOT_FOUND_CONSTANT, META_TITLE_CONSTANT, META_TAGS_CONSTANT } from '../../constants/FrontEndConstant';
import { LANGUAGE_CODE, META_TITLE_APPEND} from '../../constants/DotEnv';
class Static extends React.Component {
	constructor() {
		super();
		let meta_title = META_TITLE_CONSTANT[LANGUAGE_CODE]['pagenotfound'] + META_TITLE_APPEND;
		let meta_description = META_TAGS_CONSTANT[LANGUAGE_CODE]['meta_description'];
		let meta_keywords = META_TAGS_CONSTANT[LANGUAGE_CODE]['meta_keywords'];
		setTimeout(() => {
			window.setMeta({ "description": meta_description, "keywords": meta_keywords })
			window.setDocumentTitle(meta_title)
		}, 100)
	}
	render() {
		let redirectToNotFound = false;
		if (window.location.pathname !== "/404") {
			redirectToNotFound = true;
		}
		return (
			<main>
				{/*
				  * Every unmatched path is served index.html with an implicit 200
				  * (server.js catch-all), so this page used to look like a real page
				  * to Google — an unbounded space of 200-status "Hoppala" soft-404s.
				  *
				  * Bots are proxied through Rendertron, which honours this meta tag
				  * and returns the status on the rendered response; the middleware
				  * pipes that response through verbatim, so crawlers now get a real
				  * 404. Humans keep the 200 + SPA, which is the normal SPA tradeoff.
				  *
				  * This is deliberately not an Express-side allowlist: `/:accType`
				  * matches any single-segment path and its validity depends on a DB
				  * lookup, so a static allowlist would 404 landing pages that are
				  * still live.
				  */}
				<Helmet>
					<meta name="render:status_code" content="404" />
				</Helmet>
				{(redirectToNotFound === true) ? <Redirect to="/404" /> : null
				}
				<section class="page-title-section theme-bg d-flex justify-content-center align-items-center text-center">
					<div class="container text-white error">
						<h2 class="text-uppercase">{PAGE_NOT_FOUND_CONSTANT[LANGUAGE_CODE]['title_text']}</h2>
						<h3 class="text-white h2">{PAGE_NOT_FOUND_CONSTANT[LANGUAGE_CODE]['sub_title_text']}</h3>
					</div>
				</section>

			</main>
		);
	}
}
export default Static;